/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Modified By: rogerk
 * Created On: May 11th, 2018
 * Last Modified: July 24th, 2018
 * ****************************************************************************
 */

export { MuiThemeProvider } from '@material-ui/core/styles';
export { default as Typography } from '@material-ui/core/Typography';
export { Style } from '@material-ui/core/styles/createTypography';
export type Colors = 'inherit' | 'primary' | 'secondary' | 'default';
export type Margins = 'none' | 'dense' | 'normal';
export { PopoverOrigin } from '@material-ui/core/Popover';
export { default as CssBaseline } from '@material-ui/core/CssBaseline';
export { default as Icon } from '@material-ui/core/Icon';

export { default as AppBar } from '@material-ui/core/AppBar';
export { default as Toolbar } from '@material-ui/core/Toolbar';
export { default as Drawer } from '@material-ui/core/Drawer';

export { default as Tabs } from '@material-ui/core/Tabs';
export { default as Tab } from '@material-ui/core/Tab';

export { default as Paper } from '@material-ui/core/Paper';
export { default as Card } from '@material-ui/core/Card';
export { default as CardActions } from '@material-ui/core/CardActions';
export { default as CardContent } from '@material-ui/core/CardContent';

export { default as Snackbar } from '@material-ui/core/Snackbar';
export { default as SnackbarContent } from '@material-ui/core/SnackbarContent';

export { default as Table } from '@material-ui/core/Table';
export { default as TableBody } from '@material-ui/core/TableBody';
export { default as TableCell, Padding as CellPadding } from '@material-ui/core/TableCell';
export { default as TableHead } from '@material-ui/core/TableHead';
export { default as TablePagination } from '@material-ui/core/TablePagination';
export { default as TableRow } from '@material-ui/core/TableRow';
export { default as TableSortLabel } from '@material-ui/core/TableSortLabel';

export { default as Dialog, DialogProps } from '@material-ui/core/Dialog';
export { default as DialogTitle } from '@material-ui/core/DialogTitle';
export { default as DialogContent } from '@material-ui/core/DialogContent';
export { default as DialogContentText } from '@material-ui/core/DialogContentText';
export { default as DialogActions } from '@material-ui/core/DialogActions';

export { default as TextField } from '@material-ui/core/TextField';
export { default as FormGroup } from '@material-ui/core/FormGroup';
export { default as FormControl } from '@material-ui/core/FormControl';
export { default as FormLabel } from '@material-ui/core/FormLabel';
export { default as FormHelperText } from '@material-ui/core/FormHelperText';
export { default as FormControlLabel } from '@material-ui/core/FormControlLabel';

export { default as Tooltip } from '@material-ui/core/Tooltip';
export { default as Button } from '@material-ui/core/Button';
export { default as Select, SelectProps } from '@material-ui/core/Select';
export { default as Checkbox } from '@material-ui/core/Checkbox';
export { default as Input, InputProps } from '@material-ui/core/Input';
export { default as InputLabel } from '@material-ui/core/InputLabel';
export { default as InputAdornment } from '@material-ui/core/InputAdornment';

export { default as Switch } from '@material-ui/core/Switch';
export { default as Chip } from '@material-ui/core/Chip';
export { default as IconButton } from '@material-ui/core/IconButton';
export { default as Menu } from '@material-ui/core/Menu';
export { default as MenuItem } from '@material-ui/core/MenuItem';
export { default as Popover } from '@material-ui/core/Popover';

export { default as List } from '@material-ui/core/List';
export { default as Divider } from '@material-ui/core/Divider';

export { default as LinearProgress } from '@material-ui/core/LinearProgress';

export { default as ExpansionPanel } from '@material-ui/core/ExpansionPanel';
export { default as ExpansionPanelSummary } from '@material-ui/core/ExpansionPanelSummary';
export { default as ExpansionPanelDetails } from '@material-ui/core/ExpansionPanelDetails';
export { default as ExpansionPanelActions } from '@material-ui/core/ExpansionPanelActions';

import { createMuiTheme } from '@material-ui/core/styles';
import { } from '@material-ui/core/colors';

export const DarkGreen = {
  '50': '#9ed790',
  '100': '#8dd17d',
  '200': '#7dca6a',
  '300': '#6cc358',
  '400': '#5cbd45',
  '500': '#52AB3D',
  '600': '#499836',
  '700': '#408530',
  '800': '#377329',
  '900': '#2e6022',
  'A100': '#aedea3',
  'A200': '#bfe5b6',
  'A400': '#cfecc8',
  'A700': '#254d1b',
  contrastDefaultColor: 'light',
};

export const DarkBrown = {
  '50': '#9ed790',
  '100': '#8dd17d',
  '200': '#7dca6a',
  '300': '#6cc358',
  '400': '#5cbd45',
  '500': '#52AB3D',
  '600': '#499836',
  '700': '#408530',
  '800': '#377329',
  '900': '#2e6022',
  'A100': '#aedea3',
  'A200': '#bfe5b6',
  'A400': '#cfecc8',
  'A700': '#254d1b',
  contrastDefaultColor: 'light',
};

export const MuiTheme = createMuiTheme(
  {
    palette: {
      primary: {
        main: '#245124',
      },
      secondary: {
        main: '#e0b999',
      },
      text: {
        primary: '#202020',
        secondary: '#f0f0f0'
      }
    }
  }
);


// WEBPACK FOOTER //
// ./src/mui/index.ts